import { useTranslation } from 'react-i18next'
import type { Choice } from '@/services/merge/resolve'

interface OrderDiffProps {
  mineOrder: string[]
  theirsOrder: string[]
  currentChoice: Choice
  onChoose: (choice: Choice) => void
}

export function OrderDiff({ mineOrder, theirsOrder, currentChoice, onChoose }: OrderDiffProps) {
  const { t } = useTranslation()

  return (
    <div className="mt-1.5 space-y-2">
      <div className="grid grid-cols-2 gap-3">
        <OrderColumn
          label={t('conflict.mine', 'o meu')}
          order={mineOrder}
          chosen={currentChoice === 'mine'}
          onChoose={() => onChoose('mine')}
          otherOrder={theirsOrder}
        />
        <OrderColumn
          label={t('conflict.theirs', 'o deles')}
          order={theirsOrder}
          chosen={currentChoice === 'theirs'}
          onChoose={() => onChoose('theirs')}
          otherOrder={mineOrder}
        />
      </div>
    </div>
  )
}

function OrderColumn({
  label,
  order,
  chosen,
  onChoose,
  otherOrder,
}: {
  label: string
  order: string[]
  chosen: boolean
  onChoose: () => void
  otherOrder: string[]
}) {
  const { t } = useTranslation()

  return (
    <div>
      <button
        type="button"
        onClick={onChoose}
        className="w-full rounded-lg border px-2.5 py-1.5 text-left transition-colors mb-1"
        style={{
          borderColor: chosen ? 'var(--accent)' : 'var(--border)',
          background: chosen ? 'var(--accent-muted, color-mix(in srgb, var(--accent) 10%, transparent))' : 'var(--bg-card)',
        }}
      >
        <span
          className="text-[10px] font-medium"
          style={{ color: chosen ? 'var(--accent)' : 'var(--text-muted)' }}
        >
          {chosen ? t('conflict.selectedOrder', '✓ selecionado') : label}
        </span>
      </button>
      <ol className="space-y-0.5 text-[11px]">
        {order.map((colId, i) => {
          const otherPos = otherOrder.indexOf(colId)
          const diverges = otherPos !== -1 && otherPos !== i
          return (
            <li
              key={colId}
              className="flex items-center gap-1.5 rounded px-2 py-0.5"
              style={{
                background: diverges ? 'color-mix(in srgb, var(--color-warning, #f59e0b) 12%, transparent)' : 'transparent',
              }}
            >
              <span className="text-[10px] w-5 text-right" style={{ color: 'var(--text-dim)' }}>
                {i + 1}.
              </span>
              <span className="font-mono truncate" style={{ color: 'var(--text)' }}>
                {colId}
              </span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
